module.exports = __webpack_public_path__ + "static/logol-logo-f180051249600483b91288fbf097a2e0.png";